const overlaySelector = "[data-main-menu-overlay]"

// Watches a one pixel line across the bottom of the menu's lowest painted row.
// Anything coarser misreads the moment a hero scrolls away: observing the
// menu's whole box keeps the light colours while a sliver of hero still clips
// its top edge, leaving beige text on the beige page below.
function watchLine(reference) {
  const bottom = reference.getBoundingClientRect().bottom
  return `${-(bottom - 1)}px 0px ${bottom - window.innerHeight}px 0px`
}

// Keeps `controller.overlayValue` in sync with whether a surface the menu has
// to sit on top of — a full-bleed hero, the footer — still reaches under it.
//
// Any number of elements can carry the marker, so a page stacking several
// full-bleed surfaces keeps the menu light the whole way down. Returns a
// teardown to call from the controller's disconnect.
export function useMainMenuOverlay(controller, reference = controller.element) {
  const overlays = Array.from(document.querySelectorAll(overlaySelector))
  if (overlays.length === 0) return () => {}

  const intersecting = new Set()
  let observer

  const observe = () => {
    observer?.disconnect()
    intersecting.clear()
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            intersecting.add(entry.target)
          } else {
            intersecting.delete(entry.target)
          }
        })
        controller.overlayValue = intersecting.size > 0
      },
      { rootMargin: watchLine(reference) },
    )
    overlays.forEach((overlay) => observer.observe(overlay))
  }

  observe()
  window.addEventListener("resize", observe)

  return () => {
    observer?.disconnect()
    window.removeEventListener("resize", observe)
  }
}
